'use client';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog';
import { AlertCircle } from 'lucide-react';
import type { MatterFile } from '@/lib/services/files/types';

export interface DeleteDocumentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  document: MatterFile;
  onConfirm: () => void;
}

export function DeleteDocumentDialog({
  open,
  onOpenChange,
  document,
  onConfirm
}: DeleteDocumentDialogProps) {
  const displayName = document.displayName || document.originalFilename;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Document</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>Are you sure you want to delete "{displayName}"?</p>
            <div className="bg-warning-subtle flex items-start gap-2 rounded-lg p-3">
              <AlertCircle className="text-warning-subtle-foreground mt-0.5 h-4 w-4" />
              <div className="text-warning-subtle-foreground text-sm">
                <p className="font-medium">This action cannot be undone.</p>
                <p className="mt-1">
                  Files attached to sent correspondence cannot be deleted.
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
